import { Skeleton, Grid } from '@mui/material'
import { number, oneOfType, shape, string } from 'prop-types'
import { SkeletonStyled } from './skeleton-list.styled'

const SkeletonList = ({ height, rows, skeletonProps, ...props }) => {
	return (
		<Grid container spacing={0} {...props}>
			{[...Array(rows)].map((el, i) => {
				return (
					<SkeletonStyled
						key={i}
						variant="text"
						width={rows > 1 && i === rows - 1 ? '80%' : '100%'}
						height={height}
						{...skeletonProps}
					/>
				)
			})}
		</Grid>
	)
}

SkeletonList.defaultProps = {
	...Skeleton.defaultProps,
	height: 20,
	rows: 10,
}

SkeletonList.propTypes = {
	...Skeleton.propTypes,
	/**
	 * height of single skeleton line
	 */
	height: oneOfType([number, string]).isRequired,
	/**
	 * number of row
	 */
	rows: number.isRequired,
	/**
	 * Material Skeleton Props
	 */
	skeletonProps: shape({ ...Skeleton.propTypes }),
}

export default SkeletonList
